// YoursDreamDecoration - Premium Event Planning Platform
import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/auth";
import { PublicLayout } from "./components/Layout";
import HomePage from "./pages/HomePage";
import CategoryPage from "./pages/CategoryPage";
import PackageDetailPage from "./pages/PackageDetailPage";
import PackagesPage from "./pages/PackagesPage";
import SearchPage from "./pages/SearchPage";
import AdminLogin from "./pages/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/Dashboard";
import AdminCategories from "./pages/admin/Categories";
import AdminPackages from "./pages/admin/Packages";
import AdminOrders from "./pages/admin/Orders";
import AdminBot from "./pages/admin/BotTraining";
import AdminFestival from "./pages/admin/Festival";
import AdminSEO from "./pages/admin/SEO";
import AdminBlogs from "./pages/admin/Blogs";
import BlogListPage from "./pages/BlogListPage";
import BlogDetailPage from "./pages/BlogDetailPage";
import AboutPage from "./pages/AboutPage";
import { Chatbot } from "./components/Chatbot";
import HowItWorksPage from "./pages/HowItWorksPage";
import BookingPolicyPage from "./pages/BookingPolicyPage";

const Public = ({ children }) => {
  const loc = useLocation();
  const showChat = !loc.pathname.startsWith("/admin");
  return (
    <PublicLayout>
      {children}
      {showChat && <Chatbot />}
    </PublicLayout>
  );
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Public><HomePage /></Public>} />
          <Route path="/category/:slug" element={<Public><CategoryPage /></Public>} />
          <Route path="/package/:slug" element={<Public><PackageDetailPage /></Public>} />
          <Route path="/packages" element={<Public><PackagesPage /></Public>} />
          <Route path="/search" element={<Public><SearchPage /></Public>} />
          <Route path="/blog" element={<Public><BlogListPage /></Public>} />
          <Route path="/blog/:slug" element={<Public><BlogDetailPage /></Public>} />
          <Route path="/about" element={<Public><AboutPage /></Public>} />
          <Route path="/how-it-works" element={<Public><HowItWorksPage /></Public>} />
          <Route path="/booking-policy" element={<Public><BookingPolicyPage /></Public>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="categories" element={<AdminCategories />} />
            <Route path="packages" element={<AdminPackages />} />
            <Route path="orders" element={<AdminOrders />} />
            <Route path="bot" element={<AdminBot />} />
            <Route path="festival" element={<AdminFestival />} />
            <Route path="seo" element={<AdminSEO />} />
            <Route path="blogs" element={<AdminBlogs />} />
            <Route index element={<AdminDashboard />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
